<template>
    <v-container fluid>

        <v-layout row v-if="uxShowLogin">
            <v-flex xs12 sm6 offset-sm3>
                <v-progress-linear indeterminate v-if="uxShowSpinner"
                                   color="yellow darken-2"></v-progress-linear>

                <v-form v-model="valid">

                    <v-text-field v-model="email"
                                  :rules="[rules.required, rules.email]"
                                  v-bind:label="$t('global.email')"></v-text-field>

                    <v-text-field v-model="password"
                                  :append-icon="show ? 'visibility_off' : 'visibility'"
                                  :type="show ? 'text' : 'password'"
                                  :rules="[rules.required, rules.min]"
                                  @click:append="show = !show"
                                  v-bind:label="$t('global.password')"
                                  v-bind:hint="$t('signIn.passwordMessage')"></v-text-field>
                </v-form>
            </v-flex>
        </v-layout>
        <v-layout v-if="uxShowLogin">
            <v-flex xs12 sm6 offset-sm3>
                <v-btn small :disabled="!valid" color="info" v-on:click="uiEvent('signIn')">
                    {{$t('signIn.title')}}
                </v-btn>
                <v-btn small :disabled="!enableForgotPassword" flat color="normal" v-on:click="uiEvent('forgotPassword')">
                    {{$t('signIn.forgotPassword')}}?
                </v-btn>
            </v-flex>
        </v-layout>


        <v-layout v-if="uxShowForgotPassword">
            <v-flex xs12 sm6 offset-sm3>
                <span class="headline">
                    Kennwort vergessen
                </span>
                <br />
                <div class="mt-3">
                    Wenn ein Konto zu <b>{{email}}</b> existiert, erhalten Sie eine Mail zum
                    Zurücksetzen des Kennwortes.
                </div>
                <v-btn small color="primary" v-on:click="uiEvent('sendPasswordResetMail')" class="mt-3">
                    Mail anfordern
                </v-btn>
                <v-btn small flat color="primary" v-on:click="uiEvent('backFromPasswordReset')" class="mt-3">
                    Zurück
                </v-btn>
            </v-flex>
        </v-layout>

        <v-layout v-if="uxShowSendActivationMail">
            <v-flex xs12 sm6 offset-sm3>
                <span class="headline">
                    Ihr Konto ist nicht aktiviert.
                </span>
                <br />
                <div class="mt-3">
                    Ihr Konto wurde nach der Erstellung nicht aktiviert. Sie können hier einen neuen
                    Aktivierunglink anfordern.
                </div>
                <v-btn small color="primary" v-on:click="uiEvent('sendActivationMail')" class="mt-3">
                    Aktivierungslink anfordern
                </v-btn>
                <v-btn small color="danger" v-on:click="uiEvent('deleteAccount')" class="mt-3">
                    Konto löschen
                </v-btn>
                <v-btn small flat color="primary" v-on:click="uiEvent('backUnactivated')" class="mt-3">
                    Zurück
                </v-btn>
            </v-flex>
        </v-layout>


    </v-container>

</template>

<script>
    const config = require("./../../classes/myConfig").config;
    import firebase from "firebase/compat/app";
    import  * as firebaseAuthPromises from '../../myFirebase/firebaseAuthPromises'; 
    import  * as firebaseFirestore from '../../myFirebase/firebaseFirestore';

    export default {
        data() {
            return {
                uxShowSpinner: false,
                uxShowLogin: true,
                uxShowForgotPassword: false,
                uxShowSendActivationMail: false,

                showCreateAccount: false,
                show: false,
                valid: false,
                email: config.getTestMail(),
                password: config.getTestPassword(),
                password1: config.getTestPassword(),

                rules: {

                    required: value => !!value || "Required",

                    min: value =>  !!value && value.length >= 6 || "Mindestens 6 Buchstaben",                            

                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || "Invalid e-mail.";
                    }
                }
            };
        },

        computed: {
            enableForgotPassword() {
                
                return (this.rules.email(this.email).toString() === 'true');
            }
        },

        methods: {
            validate() {
                if (this.$refs.myform.validate()) {
                    this.valid = true
                }
            },

            uiEvent(event) {
                console.log("uiEvent : " + event);
                // Process events, that do not need store call
                switch (event) {
                    case "cancel":
                        this.$router.push({ name: "landing" });
                        return;

                    case "return":
                        this.$router.push({ name: "landing" });
                        return;

                    case "forgotPassword":
                        this.uxShowForgotPassword = true;
                        this.uxShowSendActivationMail = false;
                        this.uxShowLogin = false;
                        return;

                    case "backUnactivated":
                        this.uxShowForgotPassword = false;
                        this.uxShowSendActivationMail = false;
                        this.uxShowLogin = true;
                        firebase.auth().signOut()
                        .then( () => {
                            this.$store.commit("setSnackbarText", "Aktivieren Sie Ihr Konto. Sie wurden abgemeldet.");
                            this.$store.commit("setUser", null)
                        })
                        .catch( (error) => {
                                console.log("Error in SignOut", error);
                        })
                        break;

                    case "backFromPasswordReset":
                        this.uxShowForgotPassword = false;
                        this.uxShowSendActivationMail = false;
                        this.uxShowLogin = true;
                        break;

                    case "signIn":
                        this.uxShowSpinner = true;                        
                        firebaseAuthPromises.signIn( this.email, this.password)
                        .then(result => {
                                this.uxShowSpinner = false;
                                console.log("Store returned : " + result.code);
                                let code = result.code;
                                if (code > 0) {

                                    this.$store.commit("setSnackbarText", "Sie sind angemeldet.");
                                    this.$store.commit("setUser", firebase.auth().currentUser)
                                    this.$router.push({ name: "landing" });

                                } else if (code == 0) {

                                    this.uxShowSendActivationMail = true;
                                    this.uxShowLogin = false;

                                }
                                else {

                                    this.$store.commit("setSnackbarText", "Falsche Anmeldedaten (01)")

                                }
                            })
                            .catch(error => {
                                this.$store.commit("setSnackbarText", "Falsche Anmeldedaten (02)")
                                 this.uxShowSpinner = false
                                console.log("Action FAILED. Error :" + error);

                            });
                        break;

                    case "sendPasswordResetMail":
                            firebaseAuthPromises.sendPasswordResetEmail(this.email)
                            .then(result => {
                                console.log("Store returned : " + result.code);
                                let code = result.code;
                                if (code > 0) {this.$store.commit("setSnackbarText", "Mail gesendet."); }
                                else if (code == -1) { this.$store.commit("setSnackbarText", "Unbekannte E-Mail"); }
                                else if (code < -1) {  this.$store.commit("setSnackbarText", "E-Mail nicht gesendet. On-Line?");}
                                
                                this.uxShowForgotPassword = false;
                                this.uxShowSendActivationMail = false;
                                this.uxShowLogin = true;

                            })
                            .catch(error => {
                                this.$store.commit("setSnackbarText", "Unbekannter Fehler");
                                console.log("Action FAILED. Error :" + error);

                            });
                        break;

                    case 'deleteAccount':
                        firebaseAuthPromises.deleteAccount(this.password)
                            .then(result => {
                                if (result.code > 0) {
                                    this.$store.commit("setSnackbarText", "Konto gelöscht");
                                    this.$router.push({ name: "landing" });
                                } else {
                                    this.$store.commit(
                                        "setSnackbarText",
                                        "Konto konnte nicht gelöscht werden."
                                    );
                                }
                            });
                        break;

                    case 'sendActivationMail':
                            firebaseAuthPromises.sendActivationMail()
                            .then(result => {
                                console.log("Store returned : " + result.code);
                                let code = result.code;
                                if (code > 0) {

                                    this.$store.commit("setSnackbarText", "Mail gesendet.");

                                }

                                else {

                                    if (code == -1)
                                        this.$store.commit("setSnackbarText", "E-Mail gesendet. (02)");
                                    else if (code < -1) {
                                        this.$store.commit("setSnackbarText", "E-Mail nicht gesendet. On-Line?");
                                    }

                                }

                                this.uxShowForgotPassword = false;
                                this.uxShowSendActivationMail = false;
                                this.uxShowLogin = true;

                            })
                            .catch(error => {
                                this.$store.commit("setSnackbarText", "Unbekannter Fehler");
                                console.log("Action FAILED. Error :" + error);

                            });
                        break;


                }


            }
        }
    };
</script>
